import { Enums } from '@bode-canada/core';

export const CHART_LABEL = {
  [Enums.ChartTypeEnum.SOLD_PRICE]: 'Average Sold Price',
  [Enums.ChartTypeEnum.SOLD_PRICE_PER_SQFT]: 'Average Sold Price per Sqft',
  [Enums.ChartTypeEnum.DAYS_ON_MARKET]: 'Days On Market',
  [Enums.ChartTypeEnum.NUMBER_OF_NEW_LISTINGS]: 'Number of New Listings',
  [Enums.ChartTypeEnum.NUMBER_OF_SALES]: 'Number of Sales',
  [Enums.ChartTypeEnum.WEEKLY_VIEWS]: 'Weekly Bode Views',
};

export default {
  CHART_LABEL,
};
